<template>
    <div v-if="
			Array.isArray(dealData) &&
			dealData.length" 
			class="col-sm-3 p-4"
		>
			<div class="card custom-rounded-15 shadow-md" style="width: 18rem">
				<div class="bg-warning rounded d-flex align-items-center justify-content-center pt-2">
					<h4 class="d-flex justify-content-center">{{name}} Package</h4>
				</div>
				<div
					class="d-flex justify-content-around align-items-center fs-1 my-4 px-2"
				>
					<div v-for="index in starCount" :key="`${Math.random()  * index}`">
						<i class="bi bi-star-fill text-warning"></i>
					</div>
					
				</div>
				<div class="card-body">
					<ul class="list-group list-group-flush">
						<li
							v-for="(packageDeal) in dealData"
							:key="`${packageDeal.seasonPrice}-${Math.random()}`"
							class="list-group-item"
						>
							<b>City: {{packageDeal.city.name}} </b> <br />
							<span v-for="(hotel, index) in packageDeal.hotels" :key="`${hotel.name}-${Math.random()}`">{{`${hotel.name} ${index+1 < packageDeal.hotels.length ? ',': 'or similar hotel'} `}} </span><br />
							<span v-for="sight in packageDeal.staySights" :key="`${sight.stayPlace}-${Math.random()}`"><b>{{sight.stayPlace}}</b>:- <span v-for="sightHotel in sight.hotels" :key="`${sightHotel.name}-${Math.random()}`"> {{sightHotel.name}}</span><br />  </span><br />
							
						</li>

						
						<li class="list-group-item">
							<b>Vehicle:</b>
							{{ dealData[0]?.vehicle?.vehicleType || "-" }}
						</li>
						<li class="list-group-item">
							<b>Season Price: </b> {{ dealData[0]?.seasonPrice || "-" }}
						</li>
						<li class="list-group-item">
							<b>Off Season Price: </b> {{ dealData[0]?.offSeasonPrice || "-" }}
						</li>
					</ul>
				</div>
			</div>
		</div>
</template>
<script>
export default {
    name: "PackageHotelDealCard",

    props: {
        dealData: { type: Array, default: [] },
        name: { type: String, default: "" },
        starCount: { type: Number, default: 1 } 
    },

}
</script>